const EnvName = "demo";

let Front_URL,
  Back_URL,
  v1Url,
  decimalvalues = 1000000000000000000,
  toFixed = 6,
  NumOnly = /[^0-9]/g,
  toasterOption,
  Users_URL,
  Common_URL,
  shareTag,
  KEY = "EDAFACENFTMarketPlace#%^09276!!",
  loginurl,
  cookiename = "ssoToken",
  domainname,
  userCookieName = "userkey";

if (EnvName == "demo") {
  Front_URL = "https://edaface-listing-adminpanel.maticz.in/";
  Back_URL = "https://edafacevav-backend.maticz.in/";
  v1Url = "https://edafacevav-backend.maticz.in/api/v1/";
  Users_URL = "https://edafacevav-backend.maticz.in/api/v1/user";
  Common_URL = "https://edafacevav-backend.maticz.in/api/v1/common";
} else if (EnvName == "ip") {
} else if (EnvName == "staging") {
} else if (EnvName == "production") {
} else {
  Front_URL = "http://localhost:3000/";
  Back_URL = "http://localhost:3002/";
  v1Url = "http://localhost:3002/api/v1/";
  Users_URL = "http://localhost:3002/api/v1/user";
  Common_URL = "http://localhost:3002/api/v1/common";
}

let key = {
  Front_URL: Front_URL,
  Back_URL: Back_URL,
  Common_URL : Common_URL,
  v1Url: v1Url,
  vUrl: v1Url,
  decimalvalues: decimalvalues,
  toFixed: toFixed,
  NumOnly: NumOnly,
  toasterOption: toasterOption,
  Users_URL: Users_URL,
  shareTag: shareTag,
  KEY: KEY,
  loginurl: loginurl,
  cookiename: cookiename,
  domainname: domainname,
  userCookieName: userCookieName,
  EnvName: EnvName,
};

export default key;